.ui-command-palette__overlay {
  position: fixed;
  inset: 0;
  z-index: var(--lemn-z-modal);
  background: var(--lemn-color-overlay-scrim);
}

/*
 * Centered with auto margins, not translateX(-50%): the open animation animates
 * `transform`, which would override a positioning transform and snap the panel
 * sideways when the animation ends.
 */
.ui-command-palette__panel {
  position: fixed;
  z-index: var(--lemn-z-modal);
  top: 96px;
  left: 0;
  right: 0;
  width: 92vw;
  max-width: 560px;
  margin-inline: auto;
}

.ui-command-palette__overlay[data-state="open"] {
  animation: fade var(--lemn-duration-fast) var(--lemn-easing-standard);
}

.ui-command-palette__panel[data-state="open"] {
  animation: scale-in var(--lemn-duration-fast) var(--lemn-easing-emphasized);
}

.ui-command-palette {
  display: flex;
  flex-direction: column;
  max-height: 60vh;
  background: var(--lemn-color-surface);
  border: 1px solid var(--lemn-color-border);
  border-radius: var(--lemn-radius-large);
  box-shadow: var(--lemn-shadow-modal);
  color: var(--lemn-color-text);
  font-family: var(--lemn-font-body);
  overflow: hidden;
}

.ui-command-palette__title,
.ui-command-palette__description {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  border: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

.ui-command-palette__search {
  display: flex;
  align-items: center;
  gap: var(--lemn-space-3);
  height: 56px;
  padding: 0 var(--lemn-space-4);
  border-bottom: 1px solid var(--lemn-color-border);
  color: var(--lemn-color-text-muted);
}

.ui-command-palette__input {
  flex: 1;
  height: 100%;
  background: transparent;
  border: 0;
  color: var(--lemn-color-text);
  font-family: var(--lemn-font-body);
  font-size: var(--lemn-font-size-body);
  outline: none;
}

.ui-command-palette__input::placeholder {
  color: var(--lemn-color-text-muted);
}

.ui-command-palette__list {
  flex: 1;
  padding: var(--lemn-space-2);
  overflow-y: auto;
}

.ui-command-palette__group [cmdk-group-items] {
  display: flex;
  flex-direction: column;
  gap: var(--lemn-space-1);
}

.ui-command-palette__empty {
  padding: var(--lemn-space-6) var(--lemn-space-4);
  color: var(--lemn-color-text-muted);
  font-size: var(--lemn-font-size-body);
  text-align: center;
}

.ui-command-palette__group {
  margin-bottom: var(--lemn-space-1);
}

.ui-command-palette__group [cmdk-group-heading] {
  padding: 6px 10px;
  color: var(--lemn-color-disabled-text);
  font-size: var(--lemn-font-size-caption);
  font-weight: var(--lemn-font-weight-semibold);
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.ui-command-palette__item {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 44px;
  /* 12px left = 10px gutter + the 2px the selected bar occupies. */
  padding: 0 10px 0 12px;
  border-radius: var(--lemn-radius-small);
  color: var(--lemn-color-text);
  font-size: var(--lemn-font-size-small);
  font-weight: var(--lemn-font-weight-medium);
  cursor: pointer;
}

/* Inset bar, not border-left — an asymmetric border on a rounded box leaks
 * stray corner pixels; the inset shadow clips cleanly to the radius. */
.ui-command-palette__item[data-selected="true"] {
  background: var(--lemn-color-accent-soft);
  box-shadow: inset 2px 0 0 var(--lemn-color-accent);
}

.ui-command-palette__item-label {
  flex: 1;
}

.ui-command-palette__footer {
  display: flex;
  justify-content: center;
  gap: var(--lemn-space-4);
  padding: var(--lemn-space-3) var(--lemn-space-4);
  border-top: 1px solid var(--lemn-color-border);
  color: var(--lemn-color-disabled-text);
  font-size: var(--lemn-font-size-caption);
}

.ui-command-palette__hint {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
